export const ADULTO = "adulto"
export const NIÑO   = "niño"